// src/components/Home.js
import React, { useEffect, useRef, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Autocomplete, Button, Checkbox, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print'
import { useReactToPrint } from 'react-to-print';
// import NumPad from 'react-numpad';
import TableTabs from '../Components/TableTabs';
import axios from 'axios'
import { useNavigate } from 'react-router-dom';
import BeatLoader from "react-spinners/BeatLoader";
// Pet management is disabled for this client.
// import CustomerDialog from '../Components/AddPetDialog';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { toast } from 'react-toastify';
import { CLIENT_NAME, CLIENT_TELEPHONE } from '../config/clientInfo';
import { billingErrorMessage, postBillingRequest } from '../Data/billingAuth';
import { billingItemId, sameBillingItem, restoreHeldItems } from '../Data/billingItems';
import UserLogin from '../Components/UserLogin';
import billLogo from '../Assests/billlogo.png';
import { BRAND } from '../Data/brand';
function Billing() {

  const [isHovering, setIsHovering] = useState(false);
  const [signInOpen, setSignInOpen] = useState(false);
  const requestSignIn = () => setSignInOpen(true);
  const [refreshKey, setRefreshKey] = useState(0);
  const [bills, setBills] = useState([''])
  const [paymentMethod, setPaymentMethos] = useState('Cash')
  const [cash, setCash] = useState(0)
  const [open, setOpen] = useState(false);
  const [openDisc, setOpenDisc] = useState(false);
  const [discount, setDiscount] = useState(0)
  const [tempDisc, setTempDisc] = useState(0)
  const [serviceChargeRate, setServiceChargeRate] = useState(0);
  const [invno, setInvNo] = useState()
  const [items, setItems] = useState([])
  const [Returnitems, setReturnItems] = useState([])
  const [total, setTotal] = useState(0)
  const [metaData, setMetaData] = useState({ user: JSON.parse(localStorage.getItem("AutoParts"))?.username, Total: total, Discount: discount, Method: paymentMethod, Amount: paymentMethod === 'Card' ? total : cash })
  const [loading, setLoading] = useState(false)
  const [userDetails, setUserDetails] = useState([])
  const [treatmentItems, setTreatmentItems] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [modalItem, setModalItem] = useState(null);
  const [consumedUnits, setConsumedUnits] = useState('');

  const [animalData, setAnimalData] = useState([]);
  const [selectedPet, setSelectedPet] = useState(null);
  const [allItemsforBilling, setAllItemsForBilling] = useState([])
  const [loadingItems, setLoadingItems] = useState(true)

  const [updateBillNo, setUpdateBillNo] = useState('');
  const [updatedBillItems, setUpdatedBillItems] = useState([])
  const [updatedBillTotal, setUpdatedBillTotal] = useState(0)
  const [updateBillmetaData, setupdateBillMetaData] = useState({ user: JSON.parse(localStorage.getItem("AutoParts"))?.username, Total: updatedBillTotal, Discount: 0, Method: 'Cash', Amount: updatedBillTotal })

  // Hold bills
  const [draftInvoiceNo, setDraftInvoiceNo] = useState('');
  const [holdSearchInvoiceNo, setHoldSearchInvoiceNo] = useState('');
  const [holdSearchTableNumber, setHoldSearchTableNumber] = useState('');
  const [heldInvoiceNo, setHeldInvoiceNo] = useState('');
  const [heldTableNumber, setHeldTableNumber] = useState(null);
  const [holdBillLoading, setHoldBillLoading] = useState(false);
  const [holdActionLoading, setHoldActionLoading] = useState(false);
  const [holdBillHeaders, setHoldBillHeaders] = useState([]);
  const [holdBillsListLoading, setHoldBillsListLoading] = useState(false);
  const holdBillsCount = holdBillHeaders.length;
  const [holdPromptOpen, setHoldPromptOpen] = useState(false);
  const [holdPromptTableNumber, setHoldPromptTableNumber] = useState('');
  const [loadHoldModalOpen, setLoadHoldModalOpen] = useState(false);
  const isHoldBillLoaded = Boolean(heldInvoiceNo);

  const [isReholding, setIsReholding] = useState(false)



  // Returns

  const [returnModalOpen, setReturnModalOpen] = useState(false);
  const [returnBillNo, setReturnBillNo] = useState('');
  const [returnBillDetails, setReturnBillDetails] = useState([]);
  const [returnLoading, setReturnLoading] = useState(false);

  const finalTotal = Number(total) - Number(discount || 0);
  const serviceChargeAmount = serviceChargeRate > 0 ? finalTotal * (serviceChargeRate / 100) : 0;
  const payableTotal = finalTotal + serviceChargeAmount;
  const printableInvoiceNo = isHoldBillLoaded ? heldInvoiceNo : draftInvoiceNo;

  const navigate = useNavigate();

  const refreshHoldBillHeaders = async () => {
    setHoldBillsListLoading(true);
    try {
      const res = await axios.get('https://serverkf.ccsoftwares.com/billing/getHoldBillHeaders');
      setHoldBillHeaders(Array.isArray(res.data) ? res.data : []);
    } catch (e) {
      setHoldBillHeaders([]);
    } finally {
      setHoldBillsListLoading(false);
    }
  };

  useEffect(() => {
    if (!localStorage.getItem("AutoParts")) {
      setLoading(true)
      navigate("/Login")
    }
    else {
      setUserDetails(JSON.parse(localStorage.getItem("AutoParts")))
      //console.log(JSON.parse(localStorage.getItem("AutoParts")))
      setLoading(false)
    }
    codeRef.current.focus();


    const getAlBillableItems = () => {
      setLoadingItems(true)
      axios.get("https://serverkf.ccsoftwares.com/Item/getItemDetailsforBilling").then(res => {
        setAllItemsForBilling(res.data)
        setLoadingItems(false)
      }).catch(e => {
        ////console.log(e)
      })
    }

    getAlBillableItems()

    refreshHoldBillHeaders()
  }, [])


  const buildInvoiceNo = (invKey, date = new Date()) => {
    const year = date.getFullYear();
    const month = formatTwoDigits(date.getMonth() + 1);
    const day = formatTwoDigits(date.getDate());
    const hour = formatTwoDigits(date.getHours());
    return `${year}${month}${day}${hour}${BRAND.invoicePrefix}${invKey}`;
  };

  const getMax = async () => {
    if (isHoldBillLoaded || draftInvoiceNo) {
      return draftInvoiceNo;
    }

    setLoading(true);
    try {
      const res = await axios.get('https://serverkf.ccsoftwares.com/billing/getmaxshop1');
      const nextInvKey = res?.data?.[0]?.inv_no;
      setInvNo(nextInvKey);

      const invoiceNo = buildInvoiceNo(nextInvKey);
      setDraftInvoiceNo(invoiceNo);
      return invoiceNo;
    } catch (e) {
      toast.error('Failed to reserve invoice number');
      return '';
    } finally {
      setLoading(false);
    }
  };

  const [returnBills, setReturnBills] = useState([''])

  const getBills = () => {
    setLoading(true)


    axios.get('https://serverkf.ccsoftwares.com/billing/getshop1Bills').then(res => {
      // console.log(res.data)
      setReturnBills(res.data)


    })


  }


  const handleOpen = () => {
    setOpen(true);
    if (!isHoldBillLoaded && !draftInvoiceNo) {
      getMax();
    }
    // setCash(0)
  };
  const handleOpenDisc = () => {
    setOpenDisc(true);
  };
  const handleClose = () => setOpen(false);
  const handleCloseDisc = () => setOpenDisc(false);

  const plusBtn = () => {
    setBills([...bills, ''])
  }


  const handleClick = () => {
    setDialogOpen(true);
  };

  const styles = {
    mainContainer: {
      backgroundColor: '#FFFFFF',
      width: '100%',
      // display : 'flex',
      justifyContent: 'center',
      margin: 10,
    },
    RightContainer: {
      backgroundColor: 'white',
      // width : '60%',
      // width : '1050px',
      // height : '85vh',
      // padding : 10,
      // marginTop : -20,
      // boxShadow: '1px 1px 10px #1e1e1e',
      borderRadius: 5,
      // marginLeft : 20
    },
    sidePanel: {
      // backgroundColor : 'yellow',
      // marginRight : -10
    },
    sidepnlBtn: {
      // boxShadow: '1px 1px 10px #1e1e1e'
      borderRadius: 10
      , display: 'flex'
      , flexDirection: 'column',
      alignItems: 'center'
    },
    BillBtn: {
      boxShadow: '1px 1px 10px #1e1e1e',
      backgroundColor: isHovering ? 'white' : 'white',
      height: 50,
      borderTopLeftRadius: 10,
      borderBottomLeftRadius: 10

    },
    PlusBtn: {
      boxShadow: '1px 1px 10px #1e1e1e',
      width: 35,
      borderRadius: 10
    },
    deleteBtn: {
      width: 25,
      marginLeft: 20,

    },
    billTable: {
      backgroundColor: 'white',
      // width : '490px',
      height: '60vh',
      padding: 10,
      // boxShadow: '1px 1px 10px #1e1e1e',
      borderRadius: 5,
      display: 'flex',
      flexDirection: 'column',
      borderTopLeftRadius: 0,
      justifyContent: 'space-between',
      overflow: 'auto',
      // marginLeft : 50,

    },
    paymentSelect: {
      width: '10wh',
      backgroundColor: 'white',
      padding: 10,
      boxShadow: '1px 1px 10px #1e1e1e',
      borderRadius: 5,
      marginTop: 20

    },
    style: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      // width: 400,
      bgcolor: 'background.paper',
      border: '0px solid #000',
      boxShadow: 24,
      p: 4,
    }



  }



  useEffect(() => {

    var Total = 0.00

    for (let i = 0; i < items.length; i++) {
      Total = Total + parseFloat(items[i].Price) * parseFloat(items[i].qty)
    }

    setTotal(Total)
    codeRef.current.focus();

  }, [items])

  useEffect(() => {
    if (!isHoldBillLoaded && items.length > 0 && !draftInvoiceNo) {
      getMax();
    }
  }, [items.length, isHoldBillLoaded, draftInvoiceNo]);


  // const addToBill = (e) => {
  //   //console.log(e)
  //   if (items.length > 0) {
  //     let found = false;

  //     items.forEach((item, i) => {
  //       if (e.name === item.name) {
  //         ////console.log(item.qty)
  //         item.qty += 1;
  //         found = true;
  //         const updateItem = [...items];
  //         setItems(updateItem);
  //       }
  //     });

  //     if (!found) {
  //       const updateItem = [...items, e];
  //       setItems(updateItem);
  //     }
  //   } else {
  //     const updateItem = [...items, e];
  //     setItems(updateItem);
  //   }

  //   codeRef.current.focus();

  // }


  const handleModalSubmit = () => {
    if (consumedUnits && parseFloat(consumedUnits) > 0) {
      const unitPrice = parseFloat(modalItem.Price);
      const units = parseFloat(consumedUnits);
      const totalPrice = unitPrice * units;

      // Add the real item to treatmentItems
      const realItem = {
        ...modalItem,
        qty: units,
        totalPrice: totalPrice.toFixed(2),
      };
      setTreatmentItems((prevTreatmentItems) => [...prevTreatmentItems, realItem]);

      // Create or update the "Treatment Charges" item
      let found = false;

      const updatedItems = items.map((item) => {
        if (item.isTreatmentSummary) {
          found = true;
          const newPrice =
            parseFloat(item.Price) + totalPrice;
          return { ...item, Price: newPrice.toFixed(2) };
        }
        return item;
      });

      if (found) {
        setItems(updatedItems);
      } else {
        const newItem = {
          name: 'Treatment Charges',
          isTreatmentSummary: true,
          qty: 1,
          Price: totalPrice.toFixed(2),
        };
        setItems([...items, newItem]);
      }

      setShowModal(false);
      setModalItem(null);
      setConsumedUnits('');

      codeRef.current.focus();
    } else {
      alert('Please enter a valid number of units.');
    }
  };



  const addToBill = (e) => {

    if (items.length > 0) {
      let found = false;

      items.forEach((item, i) => {
        if (sameBillingItem(e, item)) {
          item.qty += 1;
          found = true;
          const updateItem = [...items];
          setItems(updateItem);
        }
      });

      if (!found) {
        const updateItem = [...items, { ...e, qty: 1 }];
        setItems(updateItem);
      }
    } else {
      const updateItem = [...items, { ...e, qty: 1 }];
      setItems(updateItem);
    }

    codeRef.current.focus();

  };


  const resetBill = () => {

    items.forEach((item, i) => {
      ////console.log(item.qty)
      item.qty = 1;
      const updateItem = [...items];
      setItems(updateItem);
    });
    setIsHovering(false);
    setBills([''])
    setPaymentMethos('Cash')
    setCash(0)
    setOpen(false);
    setOpenDisc(false);
    setDiscount(0)
    setTempDisc(0)
    setServiceChargeRate(0)
    setInvNo()
    setDraftInvoiceNo('');
    setHeldInvoiceNo('');
    setHeldTableNumber(null);
    setHoldSearchInvoiceNo('');
    setHoldSearchTableNumber('');
    setHoldBillLoading(false);
    setHoldActionLoading(false);
    unlockBillSubmit();
    setHoldPromptOpen(false);
    setHoldPromptTableNumber('');
    setLoadHoldModalOpen(false);
    setItems([])
    setTreatmentItems([])
    setTotal(0)
    setMetaData({ Total: total, Discount: discount, user: JSON.parse(localStorage.getItem("AutoParts"))?.userName, Method: paymentMethod, Amount: paymentMethod === 'Card' ? total : cash })
    codeRef.current.focus();

  }


  const printsRef = useRef()
  const ReturnprintsRef = useRef()
  const kitchenPrintRef = useRef()
  const shouldResetAfterPrintRef = useRef(false)
  const billSubmitInProgressRef = useRef(false)
  const [billSubmitInProgress, setBillSubmitInProgress] = useState(false)

  const lockBillSubmit = () => {
    if (billSubmitInProgressRef.current) {
      return false
    }

    billSubmitInProgressRef.current = true
    setBillSubmitInProgress(true)
    return true
  }

  const unlockBillSubmit = () => {
    billSubmitInProgressRef.current = false
    setBillSubmitInProgress(false)
  }

  const handleKitchenPrint = useReactToPrint({
    content: () => kitchenPrintRef.current,
  })

  const handlePrint = useReactToPrint({
    content: () => printsRef.current,
    onAfterPrint: () => {
      if (shouldResetAfterPrintRef.current) {
        shouldResetAfterPrintRef.current = false
        resetBill()
      }
    },
  })

  // Retained with the commented Kitchen button for this restaurant.
  // eslint-disable-next-line no-unused-vars
  const printKitchenOnly = async () => {
    if (items.length === 0) {
      toast.error('Please add items before printing the kitchen order.');
      return;
    }

    if (!isHoldBillLoaded && !draftInvoiceNo) {
      const reserved = await getMax();
      if (!reserved) return;
      setTimeout(() => {
        handleKitchenPrint();
      }, 200);
      return;
    }

    handleKitchenPrint();
  };

  const handleReturnPrint = useReactToPrint({
    content: () => ReturnprintsRef.current
  })


  const currentTime = new Date();
  const hours = formatTwoDigits(currentTime.getHours());
  const minutes = formatTwoDigits(currentTime.getMinutes());
  const seconds = formatTwoDigits(currentTime.getSeconds());

  function formatTwoDigits(value) {
    return value < 10 ? `0${value}` : value;
  }


  const returns = async () => {
    try {
      await getBills(); // Waits for getBills to complete
      // console.log(returnBills);
      setReturnModalOpen(true); // Executes after getBills is done
    } catch (error) {
      console.error("Error fetching bills:", error);
      // Handle the error as needed
    }
  };

  const handleReturnClose = () => {
    setReturnModalOpen(false);
    setReturnBillNo('');
    setReturnBillDetails(null);
    codeRef.current.focus();
  };

  const handleReturnSubmit = () => {
    if (!returnBillNo) {
      toast.error('Please enter a bill number.');
      return;
    }
    setReturnLoading(true);

    const data = {
      inv_no: returnBillNo,
    }

    // console.log(data)
    axios.post(`https://serverkf.ccsoftwares.com/billing/getBill`, data)
      .then(res => {
        setReturnBillDetails(res.data);
        // console.log(res.data);
        setReturnLoading(false);
      })
      .catch(e => {
        toast.error('Bill not found.');
        setReturnLoading(false);
      });
  };

  const getReturnDetails = () => {
    setReturnLoading(true);

    const data = {
      inv_no: returnBillNo,
    }
    axios.post(`https://serverkf.ccsoftwares.com/billing/getBill`, data)
      .then(res => {
        setReturnBillDetails(res.data);
        // console.log(res.data);
        setReturnLoading(false);
      })
      .catch(e => {
        toast.error('Bill not found.');
        setReturnLoading(false);
      });
  }

  const applyHeldBillRows = (rows) => {
    if (!Array.isArray(rows) || rows.length === 0) {
      toast.error('Hold bill not found.');
      return;
    }

    if (items.length > 0 && !isHoldBillLoaded) {
      const ok = window.confirm('This will replace the current bill. Continue?');
      if (!ok) return;
    }

    const header = rows[0];
    setHeldInvoiceNo(header.billNo || '');
    setHeldTableNumber(
      header.tableNumber === 0 || header.tableNumber
        ? parseInt(header.tableNumber, 10)
        : null
    );

    setHoldSearchInvoiceNo('');
    setHoldSearchTableNumber('');

    setDraftInvoiceNo('');
    setInvNo();
    setPaymentMethos('Cash');
    setCash(0);
    setOpen(false);
    setDiscount(parseFloat(header.discount || 0));
    setServiceChargeRate(0);
    setTreatmentItems([]);

    const mappedItems = restoreHeldItems(rows, allItemsforBilling);
    if (mappedItems.some(item => billingItemId(item) === null)) {
      toast.error('Please remove and re-add the marked items before saving this older held bill.');
    }

    setItems(mappedItems);
    codeRef.current.focus();
  };

  const loadHoldBillByInvNoValue = async (invNo) => {
    const invoiceNo = String(invNo || '').trim();
    if (!invoiceNo) return false;

    setHoldBillLoading(true);
    try {
      const res = await axios.post('https://serverkf.ccsoftwares.com/billing/getHoldBillByInvNo', {
        inv_no: invoiceNo,
      });
      if (!Array.isArray(res.data) || res.data.length === 0) {
        toast.error('Hold bill not found.');
        return false;
      }
      applyHeldBillRows(res.data);
      return true;
    } catch (e) {
      toast.error('Hold bill not found.');
      return false;
    } finally {
      setHoldBillLoading(false);
    }
  };

  const openHoldPrompt = () => {
    if (items.length === 0) {
      toast.error('Please add items before holding the bill.');
      return;
    }

    if (isHoldBillLoaded) {
      toast.error('A hold bill is already loaded. Clear it before holding a new bill.');
      return;
    }

    setHoldPromptTableNumber('');
    setHoldPromptOpen(true);
  };

  const closeHoldPrompt = () => {
    if (holdActionLoading) return;
    setHoldPromptOpen(false);
    setHoldPromptTableNumber('');
    codeRef.current.focus();
  };

  const submitHoldPrompt = async () => {
    if (holdActionLoading) return;
    const tableNo = parseInt(holdPromptTableNumber, 10);
    if (!Number.isFinite(tableNo) || tableNo <= 0) {
      toast.error('Invalid table number.');
      return;
    }

    setHoldActionLoading(true);
    try {
      await holdCurrentBill(tableNo);
    } finally {
      setHoldActionLoading(false);
    }
  };

  const openLoadHoldModal = () => {
    setLoadHoldModalOpen(true);
    setHoldSearchInvoiceNo('');
    setHoldSearchTableNumber('');
    refreshHoldBillHeaders();
  };

  const closeLoadHoldModal = () => {
    setLoadHoldModalOpen(false);
    setHoldSearchInvoiceNo('');
    setHoldSearchTableNumber('');
    codeRef.current.focus();
  };

  const holdCurrentBill = async (tableNo) => {
    if (items.length === 0) {
      toast.error('Please add items before holding the bill.');
      return;
    }

    if (isHoldBillLoaded) {
      toast.error('A hold bill is already loaded. Clear it before holding a new bill.');
      return;
    }

    if (!Number.isFinite(tableNo) || tableNo <= 0) {
      toast.error('Invalid table number.');
      return;
    }

    const invoiceNo = draftInvoiceNo || (await getMax());
    if (!invoiceNo) return;

    const individualItems = items.filter(item => !item.isTreatmentSummary);
    const allItems = individualItems.concat(treatmentItems);
    if (allItems.some(item => billingItemId(item) === null)) {
      toast.error('Please remove and re-add the marked items before saving this bill.');
      return;
    }
    const models = [];

    allItems.forEach((e) => {
      const model = {
        invoice_no: invoiceNo,
        cashier: JSON.parse(localStorage.getItem("AutoParts"))?.username,
        bill_date: `${year}-${month}-${day}`,
        bill_time: `${hours}:${minutes}`,
        product_name: e.name,
        qty: parseInt(e.qty) || parseInt(e.units) || 1,
        unit_price: parseFloat(e.Price) || parseFloat(e.totalPrice) || 0,
        gross_total: metaData.Total,
        discount: metaData.Discount,
        net_total: finalTotal,
        paymentMethod: 'HOLD',
        cash_amount: 0,
        Balance: 0,
        Item_ID: billingItemId(e),
        product_category_id: e.ItemCategoryID,
        store: CLIENT_NAME,
        stockid: e.stockId
      };
      models.push(model);
    });

    const holdData = {
      inv_no: invoiceNo,
      username: JSON.parse(localStorage.getItem("AutoParts"))?.username,
      inv_date: `${year}-${month}-${day}`,
      gross_total: metaData.Total,
      discount: metaData.Discount,
      net_total: parseFloat(finalTotal.toFixed(2)),
      shop: CLIENT_NAME,
      tableNumber: tableNo,
      items: models,
    };

    setLoading(true);
    try {
      await postBillingRequest('https://serverkf.ccsoftwares.com/billing/holdShop1Bill', holdData, requestSignIn);
      toast.success(`Bill held (Table ${tableNo})`);
      await refreshHoldBillHeaders();
      resetBill();
    } catch (e) {
      toast.error(billingErrorMessage(e, 'Failed to hold bill.'));
    } finally {
      setLoading(false);
    }
  };

  const reholdLoadedBill = async () => {
    if (holdActionLoading) return;

    if (items.length === 0) {
      toast.error('Please add items before holding the bill.');
      return;
    }

    const invoiceNo = String(heldInvoiceNo || '').trim();
    const tableNo = parseInt(heldTableNumber, 10);

    if (!invoiceNo) {
      toast.error('Invoice number not ready. Please try again.');
      return;
    }

    if (!Number.isFinite(tableNo) || tableNo <= 0) {
      toast.error('Table number not found for this held bill.');
      return;
    }

    const individualItems = items.filter(item => !item.isTreatmentSummary);
    const allItems = individualItems.concat(treatmentItems);
    if (allItems.some(item => billingItemId(item) === null)) {
      toast.error('Please remove and re-add the marked items before saving this bill.');
      return;
    }
    const models = [];

    allItems.forEach((e) => {
      const model = {
        invoice_no: invoiceNo,
        cashier: JSON.parse(localStorage.getItem("AutoParts"))?.username,
        bill_date: `${year}-${month}-${day}`,
        bill_time: `${hours}:${minutes}`,
        product_name: e.name,
        qty: parseInt(e.qty) || parseInt(e.units) || 1,
        unit_price: parseFloat(e.Price) || parseFloat(e.totalPrice) || 0,
        gross_total: metaData.Total,
        discount: metaData.Discount,
        net_total: finalTotal,
        paymentMethod: 'HOLD',
        cash_amount: 0,
        Balance: 0,
        Item_ID: billingItemId(e),
        product_category_id: e.ItemCategoryID,
        store: CLIENT_NAME,
        stockid: e.stockId
      };
      models.push(model);
    });

    const holdData = {
      inv_no: invoiceNo,
      username: JSON.parse(localStorage.getItem("AutoParts"))?.username,
      inv_date: `${year}-${month}-${day}`,
      gross_total: metaData.Total,
      discount: metaData.Discount,
      net_total: parseFloat(finalTotal.toFixed(2)),
      shop: CLIENT_NAME,
      tableNumber: tableNo,
      items: models,
    };

    setIsReholding(true);
    setLoading(true);
    setHoldActionLoading(true);
    try {
      await postBillingRequest('https://serverkf.ccsoftwares.com/billing/holdShop1Bill', holdData, requestSignIn);
      toast.success(`Bill re-held (Table ${tableNo})`);
      setIsReholding(false)

      await refreshHoldBillHeaders();
      resetBill();
    } catch (e) {
      toast.error(billingErrorMessage(e, 'Failed to hold bill.'));
    } finally {
      setHoldActionLoading(false);
      setLoading(false);
    }
  };


  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = formatTwoDigits(currentDate.getMonth() + 1); // Months are zero-based, so we add 1
  const day = formatTwoDigits(currentDate.getDate());
  const hour = formatTwoDigits(currentDate.getHours());
  const minute = formatTwoDigits(currentDate.getMinutes());
  const second = formatTwoDigits(currentDate.getSeconds());

  // ////console.log(metaData)

  useEffect(() => {
    setMetaData({ Total: total, Discount: discount, user: JSON.parse(localStorage.getItem("AutoParts"))?.userName, Method: paymentMethod, Amount: paymentMethod === 'Card' ? payableTotal : cash })
    // codeRef.current.focus();
  }, [bills, cash, discount, paymentMethod, serviceChargeRate, total, payableTotal])

  const toPrint = async () => {
    if (!lockBillSubmit()) {
      return;
    }

    let invoiceNo = isHoldBillLoaded ? heldInvoiceNo : draftInvoiceNo;
    if (!invoiceNo && !isHoldBillLoaded) {
      invoiceNo = await getMax();
    }
    if (!invoiceNo) {
      toast.error('Invoice number not ready. Please try again.');
      unlockBillSubmit();
      return;
    }

    const individualItems = items.filter(item => !item.isTreatmentSummary);
    const allItems = individualItems.concat(treatmentItems);
    if (allItems.some(item => billingItemId(item) === null)) {
      toast.error('Please remove and re-add the marked items before saving this bill.');
      unlockBillSubmit();
      return;
    }
    const models = [];
    allItems.forEach((e, i) => {
      const model = {
        invoice_no: invoiceNo,
        cashier: JSON.parse(localStorage.getItem("AutoParts"))?.username,
        bill_date: `${year}-${month}-${day}`,
        bill_time: `${hours}:${minutes}`,
        product_name: e.name,
        qty: parseInt(e.qty) || parseInt(e.units) || 1,
        unit_price: parseFloat(e.Price) || parseFloat(e.totalPrice) || 0,
        gross_total: metaData.Total,
        discount: metaData.Discount,
        net_total: payableTotal,
        paymentMethod: metaData.Method,
        cash_amount: metaData.Amount,
        Balance: metaData.Amount - payableTotal,
        Item_ID: billingItemId(e),
        product_category_id: e.ItemCategoryID,
        store: CLIENT_NAME,
        stockid: e.stockId
      };
      models.push(model);
    });
    const billingData = {
      inv_no: invoiceNo,
      username: JSON.parse(localStorage.getItem("AutoParts"))?.username,
      inv_date: `${year}-${month}-${day}`,
      gross_total: metaData.Total,
      discount: metaData.Discount,
      net_total: parseFloat(payableTotal.toFixed(2)),
      shop: CLIENT_NAME,
      paymentMethod: metaData.Method,
      serviceCharge: parseFloat(serviceChargeAmount.toFixed(2)),
      excessFoodTag: 0,
      billhold: 0,
      tableNumber: isHoldBillLoaded ? (heldTableNumber ?? -1) : -1,
      items: models, // Include the models array here
    };
    const stockUpdateItems = [];
    allItems.forEach((e, i) => {
      const stockItem = {
        itemId: billingItemId(e),
        itemCategoryId: e.ItemCategoryID,
        itemName: e.name,
        qty: parseInt(e.qty) || parseInt(e.units) || 1,
      };
      stockUpdateItems.push(stockItem);
    });
    const stockUpdateData = {
      items: stockUpdateItems,
    };

    const billingUrl = isHoldBillLoaded
      ? 'https://serverkf.ccsoftwares.com/billing/finalizeHoldShop1Bill'
      : 'https://serverkf.ccsoftwares.com/billing/CreateShop1Invoice';

    setLoading(true);
    try {
      await postBillingRequest(billingUrl, billingData, requestSignIn);
      if (isHoldBillLoaded) {
        refreshHoldBillHeaders();
      }
    } catch (e) {
      toast.error(billingErrorMessage(e, 'Failed to save bill.'));
      setLoading(false);
      unlockBillSubmit();
      return;
    }

    try {
      await axios.post('https://serverkf.ccsoftwares.com/stock/BillShop1Items', stockUpdateData);
      setRefreshKey((prevKey) => prevKey + 1);
    } catch (e) {
      toast.error('Stock update failed.');
    } finally {
      setLoading(false);
    }


    shouldResetAfterPrintRef.current = true
    handlePrint()

  }
  const toReturnPrint = () => {
    console.log(returnBillDetails)
    const Updatedmodels = [];

    returnBillDetails.forEach((e, i) => {
      const model = {
        invdetails_key: e.invdetails_key,
        invoice_no: e.inv_no,
        bill_date: `${year}-${month}-${day}`,
        bill_time: `${hours}:${minutes}`,
        qty: parseInt(e.returnQty) >= 0 ? parseInt(e.returnQty) : parseInt(e.qty),
        gross_total: (parseInt(e.returnQty) >= 0 ? parseInt(e.returnQty) : parseInt(e.qty)) * parseFloat(e.unitprice),
        unitPrice: e.unitprice,
        item_name: e.item_name
      };
      Updatedmodels.push(model);
      setUpdateBillNo(e.inv_no)
    });

    setUpdatedBillItems(Updatedmodels)

    const calculatedTotal = Updatedmodels.reduce((acc, item) => acc + item.gross_total, 0);

    console.log(Updatedmodels)
    setUpdatedBillTotal(calculatedTotal)

    console.log(calculatedTotal)


    postBillingRequest('https://serverkf.ccsoftwares.com/billing/updateBill', Updatedmodels, requestSignIn).then((res) => {
      console.log(res)
      handleReturnPrint()

    }).catch(e => {
      toast.error(billingErrorMessage(e, 'Failed to update bill.'));
    })


    // resetBill()

  }
  const UpdatedTheDeleteBill = () => {
    // Check if returnBillNo is not empty (i.e., ensure a valid invoice is selected)
    if (!returnBillNo) {
      console.log('Deletion cancelled / Select An Invoice');
      alert('Please select an invoice to delete');
      return; // Exit the function if no invoice number is selected
    }

    const data = {
      inv_no: returnBillNo,
    };

    // Show confirmation dialog
    const confirmDelete = window.confirm('Are you sure you want to delete this bill?');

    if (confirmDelete) {
      console.log(data);
      postBillingRequest('https://serverkf.ccsoftwares.com/billing/DeleteInvoices', data, requestSignIn)
        .then((res) => {
          alert('Deleted');
          setReturnModalOpen(false)
        })
        .catch((e) => {
          toast.error(billingErrorMessage(e, 'Failed to delete bill.'));
        });
    } else {
      console.log('Deletion cancelled');
    }
  };

  const changeQtyMinus = (e) => {
    if (items.length > 0) {
      let found = false;

      items.forEach((item, i) => {
        if (sameBillingItem(e, item)) {
          ////console.log(item.qty)
          item.qty -= 1;
          found = true;
          const updateItem = [...items];
          setItems(updateItem);
        }
      });

      if (!found) {
        const updateItem = [...items, e];
        setItems(updateItem);
      }
    } else {
      const updateItem = [...items, e];
      setItems(updateItem);
    }

  }




  const changeQtyPlus = (e) => {
    if (items.length > 0) {
      let found = false;

      items.forEach((item, i) => {
        if (sameBillingItem(e, item)) {
          ////console.log(item.qty)
          item.qty += 1;
          found = true;
          const updateItem = [...items];
          setItems(updateItem);
        }
      });

      if (!found) {
        const updateItem = [...items, e];
        setItems(updateItem);
      }
    } else {
      const updateItem = [...items, e];
      setItems(updateItem);
    }

  }

  const addDiscount = () => {
    setDiscount(parseInt(discount) + parseInt(tempDisc))
    handleCloseDisc()

  }

  const deleteItem = (e) => {
    setItems(items.filter(item => !sameBillingItem(item, e)))
    if (items.length - 1 < 1) {
      setDiscount(0)
    }
    codeRef.current.focus();
  }



  const makeReturn = (billDetails) => {

    // console.log(billDetails);

    const shop = JSON.parse(localStorage.getItem("AutoParts"))?.shop;

    axios.post('https://serverkf.ccsoftwares.com/billing/return1', billDetails).then((res) => {
      toast.error('Return Successful');
      getReturnDetails()
      codeRef.current.focus();
    });




  }

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      allItemsforBilling.map((e, i) => {
        //console.log("ItemId",e.ItemID)
        //console.log("codeRef.current.value",codeRef.current.value)
        if (parseInt(e.barcode) === parseInt(codeRef.current.value)) {
          //console.log(e)
          const itemDetails = e;
          itemDetails.name = e.ItemName
          itemDetails.Price = e.sellingPrice
          addToBill(itemDetails)
          codeRef.current.value = "";
        }

      })

    }
  };


  const codeRef = useRef(null);

  const handleQtyChange = (index, newQty) => {
    // Ensure the newQty is within the bounds (1 to e.qty)
    const updatedQty = Math.min(Math.max(newQty, 0), returnBillDetails[index].qty);
    // console.log(updatedQty)
    // Update the returnBillDetails array (use a copy of the array to trigger re-render)
    setReturnBillDetails(prevDetails => {
      const updatedDetails = [...prevDetails];
      updatedDetails[index] = {
        ...updatedDetails[index],
        returnQty: updatedQty,  // Store the updated return quantity
      };
      return updatedDetails;
    });

  };



  const normalizedHoldInvoiceQuery = holdSearchInvoiceNo.trim().toLowerCase();
  const normalizedHoldTableQuery = holdSearchTableNumber.trim().toLowerCase();
  const filteredHoldBillHeaders = holdBillHeaders.filter((bill) => {
    const invoiceMatches = normalizedHoldInvoiceQuery
      ? String(bill.inv_no || '').toLowerCase().includes(normalizedHoldInvoiceQuery)
      : true;
    const tableMatches = normalizedHoldTableQuery
      ? String(bill.tableNumber ?? '').toLowerCase().includes(normalizedHoldTableQuery)
      : true;
    return invoiceMatches && tableMatches;
  });

  return (
    <>
      {/* Pet management disabled: <CustomerDialog dialogOpen={dialogOpen} setDialogOpen={setDialogOpen} /> */}
      {signInOpen && <UserLogin handelOpen setHandleOpen={setSignInOpen} renewSession
        initialUsername={JSON.parse(localStorage.getItem('AutoParts') || 'null')?.username || ''}
        onLogin={session => setUserDetails(session)} />}
      {modalItem && (
        <Modal
          open={showModal}
          onClose={() => {
            setShowModal(false);
            setModalItem(null);
            setConsumedUnits('');
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 400,
              bgcolor: 'background.paper',
              borderRadius: 2,
              boxShadow: 24,
              p: 4,
            }}
          >
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Enter Consumed Units
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              Base Unit Price: {modalItem.Price} {' '}
              {modalItem.ItemCategoryID === 1 ? 'per ml' : modalItem.ItemCategoryID === 18 ? '' : 'per g'}
            </Typography>
            <TextField
              autoFocus
              label="Consumed Units"
              type="number"
              value={consumedUnits}
              onChange={(e) => setConsumedUnits(e.target.value)}
              fullWidth
              sx={{ mt: 2 }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleModalSubmit();
                }
              }}
            />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleModalSubmit}
                sx={{ mr: 1 }}
              >
                Submit
              </Button>
              <Button
                variant="outlined"
                onClick={() => {
                  setShowModal(false);
                  setModalItem(null);
                  setConsumedUnits('');
                }}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        </Modal>
      )}

      <Modal
        open={holdPromptOpen}
        onClose={closeHoldPrompt}
        aria-labelledby="hold-bill-title"
        aria-describedby="hold-bill-description"
      >
        <Box sx={{ ...styles.style, width: 420 }}>
          <Typography id="hold-bill-title" variant="h6" component="h2">
            Hold Bill
          </Typography>
          <Typography id="hold-bill-description" sx={{ mt: 1 }}>
            Enter table number
          </Typography>
          <TextField
            autoFocus
            label="Table No"
            variant="standard"
            fullWidth
            disabled={holdActionLoading}
            value={holdPromptTableNumber}
            onChange={(e) => setHoldPromptTableNumber(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                submitHoldPrompt();
              }
            }}
            sx={{ mt: 2 }}
          />
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3, gap: 1 }}>
            <Button variant="outlined" onClick={closeHoldPrompt} disabled={holdActionLoading}>
              Cancel
            </Button>
            <Button
              variant="contained"
              style={{ backgroundColor: '#9E1713', color: 'white', fontWeight: 'bold' }}
              onClick={submitHoldPrompt}
              disabled={holdActionLoading}
            >
              {holdActionLoading ? 'Holding...' : 'Hold'}
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={loadHoldModalOpen}
        onClose={closeLoadHoldModal}
        aria-labelledby="load-hold-title"
        aria-describedby="load-hold-description"
      >
        <Box sx={{ ...styles.style, width: 700, maxHeight: '80vh', overflowY: 'auto' }}>
          <Typography id="load-hold-title" variant="h6" component="h2">
            Load Held Bills
          </Typography>

          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12} md={6}>
              <TextField
                label="Invoice No"
                variant="standard"
                fullWidth
                value={holdSearchInvoiceNo}
                onChange={(e) => setHoldSearchInvoiceNo(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Table No"
                variant="standard"
                fullWidth
                value={holdSearchTableNumber}
                onChange={(e) => setHoldSearchTableNumber(e.target.value)}
              />
            </Grid>
          </Grid>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
            <Typography variant="body2" id="load-hold-description">
              Held bills: {holdBillsCount}
            </Typography>
            <Button variant="outlined" onClick={refreshHoldBillHeaders}>
              Refresh
            </Button>
          </Box>

          {holdBillsListLoading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
              <BeatLoader color="#9E1713" />
            </Box>
          ) : (
            <TableContainer component={Paper} sx={{ mt: 2, maxHeight: 420 }}>
              <Table stickyHeader size="small">
                <TableHead>
                  <TableRow>
                    <TableCell style={{ fontWeight: 'bold' }}>Invoice No</TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}>Table No</TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}>Date</TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}>Total</TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredHoldBillHeaders.map((bill) => (
                    <TableRow key={bill.inv_no}>
                      <TableCell>{bill.inv_no}</TableCell>
                      <TableCell>{bill.tableNumber}</TableCell>
                      <TableCell>{bill.inv_date}</TableCell>
                      <TableCell>{Number(bill.net_total || 0).toFixed(2)}</TableCell>
                      <TableCell>
                        <Button
                          size="small"
                          variant="contained"
                          style={{ backgroundColor: '#9E1713', color: 'white', fontWeight: 'bold' }}
                          disabled={holdBillLoading}
                          onClick={async () => {
                            const ok = await loadHoldBillByInvNoValue(bill.inv_no);
                            if (ok) {
                              closeLoadHoldModal();
                            }
                          }}
                        >
                          Load
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}

                  {filteredHoldBillHeaders.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={5} align="center">
                        {holdBillHeaders.length === 0 ? 'No held bills' : 'No matching held bills'}
                      </TableCell>
                    </TableRow>
                  ) : null}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Box>
      </Modal>
      <Grid container spacing={2} style={{ height: '100%', marginTop: 0, fontFamily: 'Arial', display: 'flex', justifyContent: 'center', flexDirection: 'row', }}>
        <Grid item xs={12} md={4}>
          <Paper style={{ backgroundColor: 'white', height: '100%', marginLeft: 10, paddingLeft: 10, paddingRight: 10, marginBottom: 10, marginTop: 50 }}>
            <Box display="flex" alignItems="center">
              {loadingItems ? <BeatLoader /> : null}
              <TextField
                id="standard-basic"
                label="Item-Code"
                variant="standard"
                onKeyPress={handleKeyPress}
                inputRef={codeRef}
                autoComplete="off"
                sx={{ flexGrow: 1, marginRight: 1 }}
              />

              {isReholding === true ? (

                <Button
                  variant="contained"
                  style={{ backgroundColor: '#FFFFFF', color: '#9E1713', border: '1px solid #9E1713', fontWeight: 'bold', marginRight: 8 }}
                  disabled={items.length === 0 || holdActionLoading}

                >
                  Updating
                </Button>
              ) : (

                <Button
                  variant="contained"
                  style={{ backgroundColor: '#9E1713', color: 'white', fontWeight: 'bold', marginRight: 8 }}
                  disabled={items.length === 0 || holdActionLoading}
                  onClick={isHoldBillLoaded ? reholdLoadedBill : openHoldPrompt}
                >
                  HOLD
                </Button>
              )
              }

              <Button
                variant="contained"
                style={{ backgroundColor: '#9E1713', color: 'white', fontWeight: 'bold' }}
                onClick={openLoadHoldModal}
              >
                LOAD ({holdBillsCount})
              </Button>

              {isHoldBillLoaded ? (
                <Button
                  variant="outlined"
                  style={{ marginLeft: 8, fontWeight: 'bold' }}
                  onClick={resetBill}
                >
                  CLEAR
                </Button>
              ) : null}

              {/* <Button
            variant="contained"
            style={{
              backgroundColor: '#9E1713',
              color: 'white',
              fontWeight: 'bold',
              fontSize: 14
            }}
            onClick={returns} // Updated to open modal
          >
            Remove Bill
          </Button> */}

            </Box>

            <Box xs={2} width={'100%'}>
              {/* bill */}
              <div style={styles.billTable}>
                <table width={'100%'}>
                  <tr style={{ backgroundColor: 'white', fontSize: 18 }} >
                    <th align='left'></th>
                    <th align='left'>Item</th>
                    <th align='center'>Qty</th>
                    <th align='center'>Price</th>
                    <th style={{ textAlign: 'center' }}>Total</th>
                  </tr>
                  <tr style={{ backgroundColor: 'White', fontSize: 18 }}>
                    <td align='center' colSpan={6}><hr></hr></td>
                  </tr>
                  {/* {items.slice().reverse().map((e,i) =>(
                  <>
                  <tr style={{fontSize:18,fontFamily : 'consolas'}}>
                    <td align='left'>{i+1}).</td>
                    <td align='left' width={100} colSpan={5}>{e.name}</td>
                  </tr>


                  <tr style={{backgroundColor : 'white',borderBottom : '2px solid black'}}>
                    <td></td>
                    <td></td>
                    <td align='center' style={{fontWeight : 'bold'}}>{ e.qty > 1 ? <button onClick={() =>{changeQtyMinus(e)}} style={{borderRadius : 50,borderWidth : 0,height:30,width:30,fontWeight : 'bold',marginRight:10,backgroundColor: '#9E1713',color: 'white',fontSize :18}}>-</button>:<><button style={{borderRadius : 50,borderWidth : 0,height:30,width:30,fontWeight : 'bold',marginRight:10,backgroundColor: '#9E1713',color: 'white',fontSize :18}}>-</button></>}{e.qty}<button onClick={() =>{changeQtyPlus(e)}} style={{borderRadius : 50,borderWidth : 0,height:30,width:30,fontWeight : 'bold',marginLeft:10,fontSize :18,backgroundColor: '#9E1713',color: 'white'}}>+</button></td>
                    <td align='center' style={{fontWeight : 'bold'}}>{e.Price}</td>
                    <td align='Right' onClick={handleOpenDisc} style={{fontWeight : 'bold'}}>{e.Price*e.qty}.00</td>
                    <td>
                    <img src ={require('../Assests/delete.png')} alt = 'billImage' style={styles.deleteBtn} width={20} onClick={() => {setItems(items.filter(item => item.name !== e.name)); setTotal(total-parseFloat(e.Price)); codeRef.current.focus();}}></img>
                    </td>
                    <td>
                    <img src ={require('../Assests/exchange.png')} alt = 'billImage' style={styles.deleteBtn} width={10} onClick={() => { setTotal(total-parseFloat(e.Price)); codeRef.current.focus();}}></img>
                    </td>

                  </tr>
                  </>
                ))} */}


                  {items.slice().reverse().map((e, i) => (
                    <>
                      <tr style={{ fontSize: 18, fontFamily: 'Consolas' }}>
                        <td align='left'>{i + 1}).</td>
                        <td align='left' width={100} colSpan={5}>
                          {e.name}
                          {billingItemId(e) === null && <span style={{ color: '#9E1713' }}> (select item again)</span>}
                        </td>
                      </tr>

                      <tr style={{ backgroundColor: 'white', borderBottom: '2px solid black' }}>
                        <td></td>
                        <td></td>
                        <td align='center' style={{ fontWeight: 'bold' }}>
                          {e.qty > 1 ? (
                            <button
                              onClick={() => { changeQtyMinus(e) }}
                              style={{
                                borderRadius: 50, borderWidth: 0, height: 30, width: 30,
                                fontWeight: 'bold', marginRight: 10, backgroundColor: '#9E1713',
                                color: 'white', fontSize: 18
                              }}>-</button>
                          ) : (
                            <button style={{
                              borderRadius: 50, borderWidth: 0, height: 30, width: 30,
                              fontWeight: 'bold', marginRight: 10, backgroundColor: '#9E1713',
                              color: 'white', fontSize: 18
                            }}>-</button>
                          )}
                          {e.qty}
                          <button
                            onClick={() => { changeQtyPlus(e) }}
                            style={{
                              borderRadius: 50, borderWidth: 0, height: 30, width: 30,
                              fontWeight: 'bold', marginLeft: 10, fontSize: 18, backgroundColor: '#9E1713',
                              color: 'white'
                            }}>+</button>
                        </td>
                        <td align='center' style={{ fontWeight: 'bold' }}>{e.Price}</td>
                        <td align='Right' onClick={handleOpenDisc} style={{ fontWeight: 'bold' }}>{e.Price * e.qty}.00</td>
                        <td>
                          <img
                            src={require('../Assests/delete.png')}
                            alt='billImage'
                            style={styles.deleteBtn}
                            width={20}
                            onClick={() => {
                              setItems(items.filter(item => !sameBillingItem(item, e)));
                              setTotal(total - (e.Price * e.qty));  // Remove item total from total
                              codeRef.current.focus();
                            }}
                          />
                        </td>
                        {/* <td>
        <img
          src={require('../Assests/exchange.png')}
          alt='billImage'
          style={styles.deleteBtn}
          width={10}
          onClick={() => {
            setItems(items.map(item => {
              if (item.name === e.name) {
                if (!item.name.includes('- ex')) {
                  return { 
                    ...item, 
                    name: `${item.name} - ex`, 
                    Price: -Math.abs(item.Price)
                  };
                }
              }
              return item;
            }));
            codeRef.current.focus();

          }}
        />
      </td> */}
                      </tr>
                    </>
                  ))}
                </table>
              </div>
              <div style={{ fontSize: 40, color: 'Black', fontWeight: 'bold', marginTop: 10 }}>
                <div>
                  Total  Rs.<label style={{ color: 'gray' }}>  {total}.00</label><br></br>
                </div>
                {/* <div style={{ fontSize: 30, color: 'gray' }}>
            Discount Rs.<label style={{ color: 'gray' }}>  {discount}.00</label><br></br>
          </div> */}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '10px' }}>
                <button
                  style={{
                    flex: 1, fontSize: 30, height: 65, fontWeight: 'bold',
                    backgroundColor: items.length > 0 && total >= 0 ? '#9E1713' : 'gray',
                    borderRadius: 5, borderWidth: 0,
                    color: "white", display: 'flex', justifyContent: 'center', alignItems: 'center'
                  }}
                  onClick={items.length > 0 && total >= 0 ? handleOpen : undefined}
                  disabled={!(items.length > 0 && total >= 0)}
                >
                  Pay Rs.{finalTotal.toFixed(2)}
                  <img src={require('../Assests/cash.png')} alt='billImage' style={{ width: 45, marginLeft: 10 }} />
                </button>

                {/* Kitchen printing is disabled for this restaurant.
                <button
                  style={{
                    width: 140, fontSize: 18, height: 65, fontWeight: 'bold',
                    backgroundColor: items.length > 0 && total >= 0 ? '#9E1713' : 'gray',
                    borderRadius: 5, borderWidth: 0,
                    color: "white", display: 'flex', justifyContent: 'center', alignItems: 'center'
                  }}
                  onClick={items.length > 0 && total >= 0 ? printKitchenOnly : undefined}
                  disabled={!(items.length > 0 && total >= 0)}
                >
                  Kitchen
                  <img src={require('../Assests/print.png')} alt='print' style={{ width: 32, marginLeft: 8 }} />
                </button>
                */}
              </div>
            </Box>
          </Paper>
        </Grid>
        {/* <Grid item xs = {12} md={8}>
        <Paper style={{ backgroundColor: 'white', height: '100%',marginRight:10 , marginTop : 50}}>
          <TableTabs bill = {addToBill}/>
        </Paper>
      </Grid> */}

        <Grid item xs={12} md={8}>
          <Paper style={{ backgroundColor: "white", height: "100%", marginRight: 10, marginTop: 50 }}>
            <TableTabs key={refreshKey} bill={addToBill} />
          </Paper>
        </Grid>

      </Grid>


      <div>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={styles.style}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Payment Methods
            </Typography>

            {/* Payment Method Selection */}
            <div>
              <RadioGroup
                row
                name="paymentMethod"
                onChange={(e) => setPaymentMethos(e.target.value)}
                value={paymentMethod}
              >
                <FormControlLabel value="Cash" control={<Radio />} label="Cash" />
                <FormControlLabel value="Card" control={<Radio />} label="Card" />
              </RadioGroup>
            </div>

            <div style={{ marginTop: 10, display: 'flex', flexDirection: 'column' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={serviceChargeRate === 10}
                    onChange={(e) => setServiceChargeRate(e.target.checked ? 10 : 0)}
                  />
                }
                label="Service Charge (10%)"
              />
            </div>


            {paymentMethod === 'Cash' ? (
              <div
                style={{
                  margin: 10,
                  display: 'flex',
                  height: '35vh',
                  flexDirection: 'column',
                  justifyContent: 'space-around',
                  alignItems: 'flex-start',
                }}
              >
                <Typography id="modal-modal-description" style={{ fontSize: 35, color: '#9E1713' }}>
                  Total : Rs.{payableTotal.toFixed(2)}
                </Typography>

                {/* Balance Calculation */}
                <Typography
                  id="modal-modal-description"
                  style={{
                    fontSize: 25,
                    color: cash - payableTotal < 0 ? '#9E1713' : '#241B1B',
                  }}
                >
                  {cash - payableTotal < 0 ? (
                    <>Balance : -- --</>
                  ) : (
                    <>Balance : Rs. {cash - payableTotal}.00</>
                  )}
                  <hr />
                </Typography>

                {/* Cash Input */}
                <TextField
                  id="standard-basic"
                  onChange={(e) => setCash(e.target.value)}
                  type="number"
                  autoComplete="off"
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && !billSubmitInProgressRef.current && cash - payableTotal >= 0) {
                      toPrint();
                    }
                  }}
                />

                {/* Print Button */}
                <div style={{ fontSize: 25, alignItems: 'center' }}></div>
                {(loading || billSubmitInProgress) && paymentMethod === 'Cash' ? (
                  <center><BeatLoader color="#9E1713" /></center>
                ) : (
                  <>
                    {cash - payableTotal < 0 ? (
                      <Button
                        style={{
                          width: '100%', height: 80, fontSize: 30, marginTop: 15,
                          fontWeight: 'bold', backgroundColor: '#A7A7A7',
                          borderRadius: 5, color: 'black',
                        }}
                        disabled
                        variant="contained"
                        startIcon={<PrintIcon style={{ fontSize: 40 }} />}
                      >
                        PRINT
                      </Button>
                    ) : (
                      <Button
                        style={{
                          width: '100%', height: 80, fontSize: 30, marginTop: 15,
                          fontWeight: 'bold', backgroundColor: '#9E1713',
                          borderRadius: 5, color: 'white',
                        }}
                        onClick={toPrint}
                        variant="contained"
                        startIcon={<PrintIcon style={{ fontSize: 40 }} />}
                      >
                        PRINT
                      </Button>
                    )}
                  </>
                )}
              </div>
            ) : (
              <div
                style={{
                  margin: 10,
                  display: 'flex',
                  height: '20vh',
                  flexDirection: 'column',
                  justifyContent: 'space-around',
                }}
              >
                <Typography id="modal-modal-description" style={{ fontSize: 35, color: '#9E1713' }}>
                  Total : Rs.{payableTotal.toFixed(2)}
                </Typography>

                {loading || billSubmitInProgress ? (
                  <center><BeatLoader color="#9E1713" /></center>
                ) : (
                  <Button
                    style={{
                      width: '100%', height: 80, fontSize: 30, marginRight: 5,
                      fontWeight: 'bold', backgroundColor: '#9E1713',
                      borderRadius: 5, color: 'white',
                    }}
                    onClick={toPrint}
                    variant="contained"
                    startIcon={<PrintIcon style={{ fontSize: 40 }} />}
                  >
                    PRINT
                  </Button>
                )}
              </div>
            )}
          </Box>
        </Modal>
      </div>



      <div>
        <Modal
          open={openDisc}
          onClose={handleCloseDisc}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={styles.style}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Discount Amount :
            </Typography>
            <br></br>
            <br></br>

            <TextField
              id="standard-basic"
              label="Discount in Rs."
              variant="standard"
              onChange={(e) => setDiscount(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  addDiscount();
                }
              }}
              type="number"
              autoComplete="off"
            />
            <br></br>
            <br></br>

            <div style={{ fontSize: 20 }}>
              <br></br>
              <br></br>
              <Button variant="outlined" onClick={() => addDiscount()} style={{ width: 300 }}>
                Add Discount
              </Button>
            </div>
          </Box>

        </Modal>
        {/* Bill */}
        <div style={{ display: 'none', position: 'relative', zIndex: 1000, justifyContent: 'center', top: 0, jeft: 0, width: '100%', height: '100%', alignItems: 'center' }}>
          <table border={0} width={'300'} style={{ fontFamily: 'Consolas', backgroundColor: 'white', fontWeight: 'bold' }} id='BillingDoc' ref={printsRef}>
            <tr>
              <td colSpan={4} align='center'>
                <img src={billLogo} alt={`${CLIENT_NAME} Logo`} width={180} style={{ marginBottom: 4 }} />
              </td>
            </tr>
            <tr>
              <td colSpan={4} align='center' style={{ fontSize: 15, fontWeight: 'bold' }}>
                <img src={require('../Assests/Call.png')} alt='' width={10} style={{ marginRight: 10 }}></img>
                Tel. {CLIENT_TELEPHONE}  <br></br>

              </td>

            </tr>
            <tr>
              <td colSpan={4} align='right'> ---------------------------------</td>
            </tr>
            <tr colSpan={4} align='center'>
              <td colSpan={4} align='left'>Cashier : {JSON.parse(localStorage.getItem("AutoParts"))?.username}</td>
            </tr>
            <tr colSpan={4} align='center'>
              <td colSpan={4} align='left'>Date : {`${year}-${month}-${day}`}</td>
            </tr>
            <tr colSpan={4} align='center'>
              <td colSpan={4} align='left'>Invoice no : {printableInvoiceNo}</td>
            </tr>
            <tr>
              <td colSpan={4} align='right'> ---------------------------------</td>
            </tr>
            {/* <tr>
              <td > </td>
              <td > Item</td>
              <td > Qty</td>
              <td > Price</td>
              <td align='center'> Total</td>
            </tr> */}
            {items?.map((e, i) => (
              <>
                <tr>
                  <td align='right'>{i + 1}<>).</></td>
                  <td colSpan={3}>{e.ItemCategoryID === 5000 ? 'Advance' : e.name}</td>
                </tr>
                <tr style={{ backgroundColor: 'white' }}>
                  <td ></td>
                  <td align='right'>{e.qty}</td>
                  <td align='center' colSpan={1}>{e.Price}</td>
                  <td align='right'>{e.qty * e.Price}.00</td>
                </tr>
              </>
            ))}
            <tr>
              <td colSpan={4} align='right'> --------------------------------- </td>
            </tr>
            <tr>
              <td colSpan={4} align='right'>Gross  Rs.{metaData?.Total}.00</td>
            </tr>
            <tr>
              <td colSpan={4} align='right'>Discount  Rs.({metaData?.Discount}.00)</td>
            </tr>
            <tr>
              <td colSpan={4} align='right'>--------------------------------- </td>
            </tr>
            <tr>
              <td colSpan={3} align='left' style={{ fontWeight: 'bold' }}>Sub Total</td>
              <td colSpan={1} align='right' style={{ fontWeight: 'bold' }}>Rs.{finalTotal.toFixed(2)}</td>
            </tr>
            {serviceChargeRate > 0 ? (
              <tr>
                <td colSpan={3} align='left' style={{ fontWeight: 'bold' }}>Service Charge ({serviceChargeRate}%)</td>
                <td colSpan={1} align='right' style={{ fontWeight: 'bold' }}>Rs.{serviceChargeAmount.toFixed(2)}</td>
              </tr>
            ) : null}
            <tr>
              <td colSpan={3} align='left' style={{ fontWeight: 'bold' }}>Total</td>
              <td colSpan={1} align='right' style={{ fontWeight: 'bold' }}>
                Rs.{payableTotal.toFixed(2)}
              </td>
            </tr>


            <tr>
              <td colSpan={4} align='right'>==========</td>
            </tr>
            <tr>
              <td colSpan={3} align='left'>{metaData?.Method} </td>
              {metaData?.Method === 'Card' ? (<>
                <td colSpan={1} align='right'>Rs.{payableTotal.toFixed(2)}</td>
              </>) :
                <td colSpan={1} align='right'>Rs.{Number(metaData?.Amount || 0).toFixed(2)}</td>
              }
            </tr>
            <tr>
              <td colSpan={3} align='left'>Balance  </td>
              {metaData?.Method === 'Card' ? (
                <>
                  <td colSpan={1} align='right'>Rs.00.00</td>
                </>
              ) : (
                <td colSpan={1} align='right'>
                  Rs.{(Number(metaData?.Amount || 0) - payableTotal).toFixed(2)}
                </td>
              )}
            </tr>
            <tr>
              <td colSpan={4} align='center' style={{ fontSize: 10 }}><br></br></td>
            </tr>
            <tr>
              <td colSpan={4} align='center' style={{ fontSize: 10 }}>Thank you, Come Again.</td>
            </tr>
            <tr>
              <td colSpan={4} align='center'>---------------------------------</td>
            </tr>

          </table>



        </div>

        {/* Kitchen Ticket */}
        <div style={{ display: 'none', position: 'relative', zIndex: 1000, justifyContent: 'center', top: 0, jeft: 0, width: '100%', height: '100%', alignItems: 'center' }}>
          <table border={0} width={'300'} style={{ fontFamily: 'Consolas', backgroundColor: 'white', fontWeight: 'bold' }} ref={kitchenPrintRef}>
            <tr>
              <td colSpan={4} align='center' style={{ fontSize: 18 }}>{CLIENT_NAME}</td>
            </tr>
            <tr>
              <td colSpan={4} align='center' style={{ fontSize: 18, fontWeight: 'bold' }}>KITCHEN ORDER</td>
            </tr>
            <tr>
              <td colSpan={4} align='center'>---------------------------------</td>
            </tr>
            <tr>
              <td colSpan={4} align='left'>Bill No : {printableInvoiceNo}</td>
            </tr>
            {isHoldBillLoaded && Number.isFinite(heldTableNumber) && heldTableNumber > 0 ? (
              <tr>
                <td colSpan={4} align='left'>Table No : {heldTableNumber}</td>
              </tr>
            ) : null}
            <tr>
              <td colSpan={4} align='left'>Date : {`${year}-${month}-${day}`} {hours}:{minutes}</td>
            </tr>
            <tr>
              <td colSpan={4} align='left'>Cashier : {JSON.parse(localStorage.getItem("AutoParts"))?.username}</td>
            </tr>
            <tr>
              <td colSpan={4} align='center'>---------------------------------</td>
            </tr>

            {items?.filter((e) => e.ItemCategoryID !== 5000)?.length > 0 ? (
              items
                ?.filter((e) => e.ItemCategoryID !== 5000)
                ?.map((e, i) => (
                  <>
                    <tr>
                      <td colSpan={3}>{i + 1}). {e.name}</td>
                      <td align='right'>{e.qty}</td>
                    </tr>
                  </>
                ))
            ) : (
              <tr>
                <td colSpan={4} align='center'>No Items</td>
              </tr>
            )}

            <tr>
              <td colSpan={4} align='center'>---------------------------------</td>
            </tr>
            <tr>
              <td colSpan={4} align='center' style={{ fontSize: 10 }}>Send to kitchen</td>
            </tr>
            <tr>
              <td colSpan={4} align='center'>---------------------------------</td>
            </tr>
          </table>
        </div>

        {/* Return Bill */}
        <div style={{ display: 'none', position: 'relative', zIndex: 1000, justifyContent: 'center', top: 0, jeft: 0, width: '100%', height: '100%', alignItems: 'center' }}>
          <table border={0} width={'300'} style={{ fontFamily: 'Consolas', backgroundColor: 'white', fontWeight: 'bold' }} id='BillingDoc' ref={ReturnprintsRef}>
            <tr>
              <td colSpan={4} align='center'>
                <img src={billLogo} alt={`${CLIENT_NAME} Logo`} width={180} style={{ marginBottom: 4 }} />
              </td>
            </tr>
            <tr>
              <td colSpan={4} align='center' style={{ fontSize: 14, fontWeight: 'bold' }}>
                <img src={require('../Assests/whatsapp.png')} alt='' width={10} style={{ marginRight: 10 }}></img>
                Tel. {CLIENT_TELEPHONE}  <br></br>
                <img src={require('../Assests/Call.png')} alt='' width={10} style={{ marginRight: 10 }}></img>
                Tel. {CLIENT_TELEPHONE}  <br></br>

              </td>

            </tr>
            <tr>
              <td colSpan={4} align='right'> ---------------------------------</td>
            </tr>
            <tr colSpan={4} align='center'>
              <td colSpan={4} align='left'>Cashier : {JSON.parse(localStorage.getItem("AutoParts"))?.username}</td>
            </tr>
            <tr colSpan={4} align='center'>
              <td colSpan={4} align='left'>Date : {`${year}-${month}-${day}`}</td>
            </tr>
            <tr colSpan={4} align='center'>
              <td colSpan={4} align='left'>Invoice no : {updateBillNo}</td>
            </tr>
            <tr>
              <td colSpan={4} align='right'> ---------------------------------</td>
            </tr>
            {/* <tr>
              <td > </td>
              <td > Item</td>
              <td > Qty</td>
              <td > Price</td>
              <td align='center'> Total</td>
            </tr> */}
            {updatedBillItems
              ?.filter((e) => e.qty > 0) // Filter out items with qty = 0
              .map((e, i) => (
                <React.Fragment key={i}>
                  <tr>
                    <td align="right">{i + 1}<>).</></td>
                    <td colSpan={3}>{e.item_name}</td>
                  </tr>
                  <tr style={{ backgroundColor: 'white' }}>
                    <td></td>
                    <td align="right">{e.qty}</td>
                    <td align="center" colSpan={1}>{e.unitPrice}</td>
                    <td align="right">{e.qty * e.unitPrice}.00</td>
                  </tr>
                </React.Fragment>
              ))}
            <tr>
              <td colSpan={4} align='right'> --------------------------------- </td>
            </tr>
            <tr>
              <td colSpan={4} align='right'>Gross  Rs.{updatedBillTotal}.00</td>
            </tr>
            <tr>
              <td colSpan={4} align='right'>Discount  Rs.(00.00)</td>
            </tr>
            <tr>
              <td colSpan={4} align='right'>--------------------------------- </td>
            </tr>
            <tr>
              <td colSpan={3} align='left' style={{ fontWeight: 'bold' }}>Total</td>
              <td colSpan={1} align='right' style={{ fontWeight: 'bold' }}>
                Rs.{(updatedBillTotal - (updateBillmetaData?.Discount || 0)).toFixed(2)}
              </td>
            </tr>
            <tr>
              <td colSpan={4} align='right'>==========</td>
            </tr>
            {/* <tr>
              <td colSpan={3} align='left'>{updateBillmetaData?.Method} </td>
                {updateBillmetaData?.Method === 'Card' ? (<>
                  <td colSpan={1} align='right'>Rs.{updatedBillTotal-updateBillmetaData?.Discount}.00</td>
                </>):
                  <td colSpan={1} align='right'>Rs.{updateBillmetaData?.Amount}.00</td>
                }
            </tr> */}
            {/* <tr>
              <td colSpan={3} align='left'>Balance  </td>
              {updateBillmetaData?.Method === 'Card' ? (<>
                <td colSpan={1} align='right'>Rs.00.00</td>
              </>):
                <td colSpan={1} align='right'>Rs.{updateBillmetaData?.Amount-(updateBillmetaData?.Total-updateBillmetaData?.Discount)}.00</td>
              }
            </tr> */}

            <tr>
              <td colSpan={4} align='center' style={{ fontSize: 12 }}>Thank you, Come Again.</td>
            </tr>
            <tr>
              <td colSpan={4} align='center'></td>
            </tr>

          </table>



        </div>

        {/* Return Model */}
        <Modal
          open={returnModalOpen}
          onClose={handleReturnClose}
          aria-labelledby="return-modal-title"
          aria-describedby="return-modal-description"
        >
          <Box sx={styles.style}>
            <Typography id="return-modal-title" variant="h6" component="h2">
              Return Bill Details for {CLIENT_NAME}
            </Typography>

            <div>
              <Grid container spacing={1}>
                <Grid xs={12} md={12}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', margin: 20 }}>

                    <Autocomplete
                      options={returnBills} // Pass the entire array of bill objects
                      getOptionLabel={(option) => option.inv_no || ''} // Extract 'inv_no' for display
                      value={
                        returnBills.find((bill) => bill.inv_no === returnBillNo) || returnBillNo || ''
                      } // Set the value to the selected bill object or the entered string
                      onChange={(event, newValue) => {
                        if (typeof newValue === 'string') {
                          // User typed a bill number
                          setReturnBillNo(newValue);
                        } else if (newValue && newValue.inv_no) {
                          // User selected a bill from the dropdown
                          setReturnBillNo(newValue.inv_no);
                        } else {
                          // Handle cases like clearing the input
                          setReturnBillNo('');
                        }
                      }}
                      freeSolo // Allow users to enter values not present in the list
                      renderOption={(props, option) => (
                        <li {...props} key={option.inv_no}>
                          {option.inv_no}
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Enter Bill Number"
                          variant="standard"
                          fullWidth
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              handleReturnSubmit();
                            }
                          }}
                        />
                      )}
                      noOptionsText="No matching bill numbers"
                      style={{ width: 300 }}
                    />
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleReturnSubmit}

                      style={{ marginLeft: 20, fontSize: 15 }}
                    >
                      Search
                    </Button>
                  </div>
                  <hr></hr>

                  <Grid xs={12} md={12}>
                    <div>
                      {/* Display the bill details */}
                      <TableContainer
                        component={Paper}
                        style={{
                          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                          height: 400, // Set the maximum height for the container
                          overflowY: 'auto',  // Enable vertical scrolling
                        }}
                      >
                        <Table stickyHeader style={{ minWidth: 650 }} >
                          <TableHead>
                            <TableRow style={{ backgroundColor: '#9E1713' }}>
                              <TableCell style={{ color: 'White', fontWeight: 'bold', backgroundColor: '#9E1713' }}>Invoice No</TableCell>
                              <TableCell style={{ color: 'White', fontWeight: 'bold', backgroundColor: '#9E1713' }}>Item Name</TableCell>
                              <TableCell style={{ color: 'White', fontWeight: 'bold', backgroundColor: '#9E1713' }}>Updated Qty</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {returnBillDetails?.map((e, i) => (
                              <TableRow key={i} style={i % 2 === 0 ? { backgroundColor: '#f9f9f9' } : {}}>
                                <TableCell>{e.inv_no}</TableCell>
                                <TableCell>{e.item_name}</TableCell>

                                {/* Editable qty field */}
                                <TableCell>
                                  {e.qty}
                                  {/* <input
                  type="number"
                  value={e.returnQty !== undefined ? e.returnQty : e.qty}  // Default to e.qty if no returnQty is set
                  min="0"
                  max={e.qty}  // Prevent the return quantity from exceeding the total purchased quantity
                  onChange={(event) => handleQtyChange(i, event.target.value)}
                  style={{ width: '50px', textAlign: 'center', height: 30, fontSize: 20 }}
                /> */}
                                </TableCell>

                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                  </Grid>



                  {/* <Button
                            variant="contained"
                            color="primary"
                            onClick={toReturnPrint}
                            sx={{ mt: 2 }}
                            fullWidth
                            style={{fontSize:15,fontWeight : 'bold'}}
                          >
                            Reprint Bill 
                          </Button> */}
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={UpdatedTheDeleteBill}
                    sx={{ mt: 2 }}
                    fullWidth
                    style={{ fontSize: 15, fontWeight: 'bold' }}
                  >
                    Remove BILL

                  </Button>
                </Grid>



              </Grid>
            </div>


            {returnLoading && (
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                <BeatLoader color="#9E1713" />
              </Box>
            )}
          </Box>
        </Modal>

      </div>
    </>
  )
}

export default Billing
